import { createContext, useContext } from 'react';
import { IDataPackageContext } from '@vivli/shared/features/data-package/infrastructure/interface';

export const DataPackageContext = createContext<IDataPackageContext>(null);

//this conext is implemented by use-data-package.hook.ts
export const useDataPackageContext = () => {
    return useContext(DataPackageContext);
};
